module.exports = __webpack_public_path__ + "media/images/icons/outlined/database-e564c3b7b809faa0c09ebe500151d92c.svg";